import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import MoodDepressedIcon from '../../assets/icons/mood-depressed.svg';
import MoodSadIcon from '../../assets/icons/mood-sad.svg';
import MoodOkayIcon from '../../assets/icons/mood-okay.svg';
import MoodHappyIcon from '../../assets/icons/mood-happy.svg';
import { BorderlessButton } from '../buttons';
import { Edit, ArrowDown, ArrowUp } from '../icons';
import Modal from '../Modal';
import DiaryEntryEditContainer from '../../containers/DiaryEntryEditContainer';

class DiaryEntryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showHiddenContent: false,
      editDiaryEntryOpen: false
    };

    this.showHiddenContent = this.showHiddenContent.bind(this);
    this.hideHiddenContent = this.hideHiddenContent.bind(this);

    this.openEditDiaryEntry = this.openEditDiaryEntry.bind(this);
    this.closeEditDiaryEntry = this.closeEditDiaryEntry.bind(this);
  }

  showHiddenContent() {
    this.setState({ showHiddenContent: true });
  }

  hideHiddenContent() {
    this.setState({ showHiddenContent: false });
  }

  openEditDiaryEntry() {
    this.setState({ editDiaryEntryOpen: true });
  }

  closeEditDiaryEntry() {
    this.setState({ editDiaryEntryOpen: false });
  }

  render() {
    const feelings = {
      depressed: MoodDepressedIcon,
      sad: MoodSadIcon,
      okay: MoodOkayIcon,
      happy: MoodHappyIcon
    };

    const formatDate = date => moment(date).format('MMM Do, YYYY');
    const formatTime = date => moment(date).format('h:mm A');

    const { entry, t } = this.props;
    const displayContent = !entry.hidden || this.state.showHiddenContent;
    const showUi = this.state.showHiddenContent ? (
      <div className="diary-entry__footer-hide">
        {t('diaryEntryView.hidden')}{' '}
        <BorderlessButton
          onClick={this.hideHiddenContent}
          label={t('diaryEntryView.hideEntry')}
          IconRight={ArrowUp}
          colorScheme="blue"
        />
      </div>
    ) : (
      <div className="diary-entry__footer-show">
        {t('diaryEntryView.hidden')}{' '}
        <BorderlessButton
          onClick={this.showHiddenContent}
          label={t('diaryEntryView.showEntry')}
          IconRight={ArrowDown}
          colorScheme="blue"
        />
      </div>
    );

    return (
      <div className="diary-entry">
        <Modal
          isOpen={this.state.editDiaryEntryOpen}
          onRequestClose={this.closeEditDiaryEntry}
        >
          <DiaryEntryEditContainer
            entry={this.props.entry}
            onDiaryEntrySaved={this.closeEditDiaryEntry}
          />
        </Modal>
        <div className="diary-entry__header">
          <div className="diary-entry__timestamp">
            <p className="diary-entry__date">
              {formatDate(this.props.entry.createdAt)}
            </p>
            <p className="diary-entry__time">
              {t('diaryEntryView.postedAt', {
                time: formatTime(this.props.entry.createdAt)
              })}
            </p>
          </div>
          <div className="diary-entry__feeling-container">
            <div
              className={`diary-entry__feeling diary-entry__feeling--${this
                .props.entry.feeling}`}
            >
              {t('diaryEntryView.feeling')}
              <img
                src={feelings[this.props.entry.feeling]}
                alt={t(`diary.${this.props.entry.feeling}`)}
                className="diary-entry__feeling-icon"
              />
            </div>
          </div>
        </div>
        {displayContent ? (
          <div className="diary-entry__content">{this.props.entry.content}</div>
        ) : null}
        <div className="diary-entry__footer">
          {this.props.entry.hidden ? showUi : null}
          <div className="diary-entry__footer-edit">
            <BorderlessButton
              onClick={this.openEditDiaryEntry}
              label={t('diaryEntryView.editEntry')}
              IconLeft={Edit}
              colorScheme="blue"
            />
          </div>
        </div>
      </div>
    );
  }
}

DiaryEntryView.propTypes = {
  entry: PropTypes.shape({
    id: PropTypes.string,
    content: PropTypes.string,
    feeling: PropTypes.string,
    hidden: PropTypes.bool,
    createdAt: PropTypes.string
  }).isRequired,
  t: PropTypes.func.isRequired
};

export default translate()(DiaryEntryView);



// WEBPACK FOOTER //
// ./src/components/diary/DiaryEntryView.js